import { useTranslation } from "react-i18next";
import { PageHeader } from "@/components/ui";
import { ModelTypesManager } from "@/components/common/forms/models/model-types-manager";

export function TypeModels() {
  const { t } = useTranslation();
  return <section className="space-y-7">
    <PageHeader eyebrow="Contratos" title={t("LABEL.type of models")} lede="As categorias que organizam os modelos de contrato da clínica." />
    <ModelTypesManager />
  </section>;
}
